// 与 jsm/loaders/*.js 同样的 shim 模式：re-export 官方 r180 addons 实现。
//
// 注意 libs/three.js/examples/jsm/renderers/CSS3DRenderer.js 里用的是裸标识符
// `from 'three'`。因为 libs/three.js/package.json 声明了 "name": "three" 且带
// exports 字段，Node/rollup 会走「包自引用」把它解析回
// libs/three.js/build/three.module.js —— 也就是 Potree 自己用的那个 THREE 实例，
// 不会引入第二份 three（bundle 里 class Vector3 只有一份，已验证）。
export { CSS3DRenderer, CSS3DObject, CSS3DSprite } from '../../libs/three.js/examples/jsm/renderers/CSS3DRenderer.js';
